<template>
  <div class="app_bottom_logo">
    <img src="@/assets/images/text_logo.png" />
  </div>
</template>
